<script>
import { Doughnut, mixins } from 'vue-chartjs'
// reactiveProp enlaza automáticamente chartData/props con el gráfico
const { reactiveProp } = mixins

export default {
  name: 'PieChart',
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartData: { type: Object, required: true },  // { labels, datasets }
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        plugins: {
          datalabels: {
            display: false // 👈 sin datalabels
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const ds = data.datasets[tooltipItem.datasetIndex]
              const value = ds.data[tooltipItem.index]

              const label = data.labels[tooltipItem.index] || ''
              return `${label}: ${ Number(value).toLocaleString("de-De", {minimumFractionDigits: 0, maximumFractionDigits: 2})} %`
            }
          }
        }
      })
    }
  },
  mounted () {
    // renderiza al montar; reactiveProp actualizará en cambios posteriores
    this.renderChart(this.chartData, this.options)
  }
}
</script>
